export default "__VITE_ASSET__809e44e8__"